module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/en-顶部修饰图.680a6a4c.png";